module.exports = __webpack_public_path__ + "img/grey.19ae1a13.png";